/* eslint-disable max-len */
import React from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import CustomAccordion from '../common/CustomAccordion';

const useStyles = makeStyles(() => ({
  faqContainer: {
    backgroundColor: '#F5F5F5',
    borderRadius: '5px',
    marginTop: '10px',
    padding: '24px 16px',
  },
  typographyDesc: {
    fontSize: '12px',
    lineHeight: '18px',
    marginTop: '10px',
  },
  typographyTitle: {
    color: '#172B4D',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '18px',
  },
}));

const faqList = [
  {
    _id: 'personalized-faq-1',
    description:
      "If you don't have either your radiology images or report, you can reach out to our team at info@mediphany.com and we will gladly help you get them from your imaging center.",
    title: "What if I don't have my radiology files?",
  },
  {
    _id: 'personalized-faq-2',
    description: 'If you have been provided with a physical copy of your radiology report, you can simply take a photo of the report and upload it.',
    title: 'What if I have a physical radiology report?',
  },
  {
    _id: 'personalized-faq-3',
    description:
      'The length of your video report depends on the complexity of the findings, but typically our personal reports range from 5-10 minutes in length and there are additional videos provided to enhance your understanding.',
    title: 'How long will my video report be?',
  },
  {
    _id: 'personalized-faq-4',
    description:
      'If you select the standard report, your video report will be available to you in less than 5 days from the time we receive your images and text report. If you select the express report, then your video report will be available in less than 48 hours from the time we receive your images and text report.',
    title: 'How long will it take to receive my video report?',
  },
  {
    _id: 'personalized-faq-5',
    description: 'Yes, our radiologists can give detailed video explanations for any type of condition that can be detected on the imaging study.',
    title: 'Can Mediphany do this for any type of radiology study or condition?',
  },
  {
    _id: 'personalized-faq-6',
    description:
      'Yes, absolutely. Our systems have been developed from the start with security in mind and we ensure that we are HIPAA compliant for maximum security. Nobody outside of Mediphany will be able to view your video report or imaging files unless you have invited them to do so.',
    title: 'Is my medical information safe?',
  },
];

export default () => {
  const classes = useStyles();

  const RenderTitle = (title) => {
    return <Typography className={classes.typographyTitle}>{title}</Typography>;
  };

  const RenderDescription = (description) => {
    return <Typography className={classes.typographyDesc}>{description}</Typography>;
  };

  return (
    <div>
      {faqList.map((faq) => {
        return (
          <div key={faq._id} className={classes.faqContainer}>
            <CustomAccordion title={RenderTitle(faq.title)}>{RenderDescription(faq.description)}</CustomAccordion>
          </div>
        );
      })}
    </div>
  );
};
